import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import useAccount from "src/features/account/hooks/useAccount";
import { LineSeparator } from "banafo-design-system";
import PlanDetailsSection from "src/features/account/planDetails/PlanDetailsSection";
import PaymentsHistorySection from "src/features/payments/payments/PaymentsHistorySection";
import InvoicesUpgradeScreen from "src/features/invoices/InvoicesUpgradeScreen";
const Invoices = () => {
    const { subscriptionPlan: { isFree } } = useAccount();
    return (_jsxs(_Fragment, { children: [isFree && _jsx(InvoicesUpgradeScreen, {}), !isFree &&
                _jsxs(_Fragment, { children: [_jsx(LineSeparator, { color: '400', size: 2 }), _jsx(PlanDetailsSection, {}), _jsx(LineSeparator, { color: '400', size: 2 }), _jsx(PaymentsHistorySection, {})] })] }));
};
export default Invoices;
